import React, {Component, Fragment} from "react";
import {
  formsUpdater,
  getFormFieldValue,
  setFormFieldValue,
  traversePropertiesArray
} from "../../Applications/shared/shared";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {getData, postData} from "../../../api/doLogin";
import {EventClient} from "../../../util/eventClient";
import {toast, ToastContainer} from 'react-toastify';
import {replaceBody, replaceSubject} from "../../../util/templateHelpers";
import Select from "react-select";
import '../../../../scss/vendors/react-select/react-select.scss';

export class EmailAccessCode extends Component {
  constructor(props) {
    super(props);
    let subject = "";
    let body = "";
    console.log(props.user);
    if (props.templates) {
      props.templates.map((template) => {
        if (template.templateName === props.applicant['type']) {
          subject = replaceSubject(template['emailSubject'], {
            ...props.applicant, ...props.user,
            fName: props.applicant['name'],
            fullSignature: props.user['repFullSignature'],
            bizCard: props.user['repBizCard']
          });
          body = replaceBody(template['emailTemplate'], {
            ...props.applicant, ...props.user,
            fName: props.applicant['name'],
            fullSignature: props.user['repFullSignature'],
            bizCard: props.user['repBizCard']
          });
        }
      });
    }
    let files = [];
    if (props.files.length > 0) {
      props.files.map(file => {
        files.push({value: `careers/${file.name}`, label: `${file.name}`});
      })
    }
    this.state = {
      dataLoaded: false,
      data: [],
      formData: {
        id: props.applicant['id'],
        to: props.applicant['email'],
        from: props.user['repEmail'],
        subject: subject,
        body: body,
        attachments: []
      },
      files: files,
      showIndicator: false
    };
    this.emailAccess.bind(this);
  }

  componentWillMount() {
    EventClient.on('EMAIL_ACCESS_CODE', () => this.emailAccess(), "EmailAccessCode");

  }

  componentWillUnmount() {
    EventClient.off('EMAIL_ACCESS_CODE', () => this.emailAccess, "EmailAccessCode");
  }

  shouldComponentUpdate(nextProps, nextState) {
    // like writing return true
    return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  }

  emailAccess() {
    let self = this;
    // if (getFormFieldValue(this.state.formData['code']) === "") {
    //   toast.error("Please Enter Code");
    //   return;
    // }
    // if (getFormFieldValue(this.state.formData['name']) === "") {
    //   toast.error("Please Enter First Name");
    //   return;
    // }
    // if (getFormFieldValue(this.state.formData['lname']) === "") {
    //   toast.error("Please Enter Last Name");
    //   return;
    // }
    // if (getFormFieldValue(this.state.formData['email']) === "") {
    //   toast.error("Please Enter Email");
    //   return;
    // }
    // if (getFormFieldValue(this.state.formData['type']) === "") {
    //   toast.error("Please Select Template");
    //   return;
    // }
    // console.log({...this.state.formData});
    postData("careers/access/email", {...this.state.formData}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          toast.success("Sent");
          setTimeout(() => {
            if (self.props.onSave) {
              self.props.onSave();
            }
          }, 1500);
        } else {
          toast.error(data.message);
          if (self.props.onError){
            self.props.onError();
          }
        }
      })
      .catch(error => {
        console.error(error);
        toast.error("Didn't work");
        if (self.props.onError){
          self.props.onError();
        }
      });
  }

  validate(evt, type) {
    if (evt.target.value.length === 0) return;
    console.log(evt.target.value, type);
    let check;

    function alertMessage(text, field) {
      alert(`Please enter a valid ${text} in ${field}`);
    }

    switch (type) {
      case "dollar":
        check = /^[0-9]+(\.[0-9][0-9])?$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("number", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
      case "email":
        check = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("email", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;

      case "percentage":
        check = /^(100|[1-9]?\d{1})$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("number from 0-100", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
      case "datetime":
        check = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01]) (00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9])$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("date", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
    }
  }

  render() {
    const containerStyle = {
      zIndex: 1999
    };
    return (
      <Fragment>
        <ToastContainer position="bottom-right" autoClose={1500} style={containerStyle}/>
        <Row>
          <Col xs={9}>

            <FormGroup>
              <Label for="to">To</Label>
              <Input
                placeholder={"To Email"}
                type="text"
                id="to"
                value={getFormFieldValue(this.state.formData['to'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                onBlur={(evt) => this.validate(evt, "email")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <FormGroup>
              <Label for="from">From</Label>
              <Input
                placeholder={"From Email"}
                type="text"
                id="from"
                value={getFormFieldValue(this.state.formData['from'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                onBlur={(evt) => this.validate(evt, "email")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label for="subject">Subject</Label>
              <Input
                type="text"
                id="subject"
                value={getFormFieldValue(this.state.formData['subject'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label for="body">Body</Label>
              <Input
                type="textarea"
                style={{height: 200}}
                id="body"
                value={getFormFieldValue(this.state.formData['body'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label htmlFor="attachments">Chosen&nbsp;Attachments*</Label>
              <Select
                id="attachments"
                name="attachments"
                value={traversePropertiesArray(this.state.formData, ["attachments"])}
                options={this.state.files}
                onChange={(selectedApps) => setFormFieldValue("attachments", selectedApps.map(r => r.value), this.state.formData, false, (data) => {
                  this.setState({formData: data});
                })}
                multi
              />
            </FormGroup>
          </Col>
        </Row>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Careers/views/EmailAccessCode.js